export default {
  image: {
    include_image_sizes: true,
  },
  team: {
    include_team_members: true,
    include_team_user_ids: true,
  },
  teamMember: {
    include_team_member_user: true,
  },
  user: {
    include_user_image: true,
  },
}
